export { default } from './react-pannellum';
export * from './react-pannellum';
